import { Box, Container } from '@mui/material'
import PageHeader from 'components/common/PageHeader/PageHeader';
import CustomButton from 'components/buttons/CustomButton/CustomButton';
import useGlobalStyles from 'styles/globalStyles';
import CustomCarousel from 'components/common/CustomCarousel/CustomCarousel';
import CategoryTree from 'components/Category/CategoryTree/CategoryTree';
// import AllPatients from 'components/tables/AllPatients/AllPatients';

export default function CategoriesPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Container
      maxWidth={'xl'}
      className={globalStyles.container}
    >
      <Box pt={2}>
        <PageHeader
          title={'Overview'}
          buttons={[]}
        />
      </Box>

      <Box mt={3}>
        <CategoryTree />
      </Box>
    </Container>
  )
}
